import React, { useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../../../imageService';
import usePlayOnceGif from '../../../hooks/usePlayOnceGif';

const IMAGES = {
  logo: '/images/24ua-lm-spl-test/logo.png',
  bgPoster: '/images/24ua-lm-spl-test/bg-poster.png',
  lensPack: getImageFromS3('images/24ua-lm-spl/lens-pack.png'),
  pack: getImageFromS3('images/24ua-lm-spl/pack.png'),
  filter: getImageFromS3('images/24ua-lm-spl/filter.gif'),
  tobacco: getImageFromS3('images/24ua-lm-spl/tobacco.png'),
  bgVideo: getImageFromS3('images/24ua-lm-spl/bg.mp4')
};

const PROJECT_ID = '24UA-LM-Spl-test';

const LINE_TITLE = 'Loft Splash';
const TAR = '5';
const NICOTINE = '0.4';

const SHOP_LINKS = {
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/producer=b84d5fce/',
  cigPoshta: 'https://cig-poshta.in.ua/shop/lm/?utm_source=SP'
};

const ChevronIcon = () => (
  <svg
    className={styles.chevron}
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13.5" cy="13.5" r="13" stroke="white" />
    <path
      d="M11.95 7.9L17.55 13.5L11.95 19.1"
      stroke="white"
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ShopButton = ({ href, label }) => (
  <a
    className={styles.shopButton}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span className={styles.shopGlassTop} />
    <span className={styles.shopGlassBottom} />
    <span className={styles.shopGlassCore} />
    <span className={styles.shopLabel}>{label}</span>
  </a>
);

const HomeScreen = ({
  handleToReview,
  handleToAuthority,
  handleToAllBrands
}) => {
  const { init, sendEvent } = useContext(DataLayerEventContext);
  const filterSrc = usePlayOnceGif(IMAGES.filter);

  useEffect(() => {
    init(PROJECT_ID);
    sendEvent('seen_product_content');
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.videoLayer}>
        <div className={styles.videoBox}>
          <video
            src={IMAGES.bgVideo}
            poster={IMAGES.bgPoster}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          />
        </div>
      </div>

      <span className={styles.topGlow} />

      <div className={styles.content}>
        <img className={styles.logo} src={IMAGES.logo} alt="L&M Loft" />

        <div className={styles.packBox}>
          <span className={styles.packGlow} />
          <img className={styles.pack} src={IMAGES.pack} alt={LINE_TITLE} />
        </div>

        <p className={styles.lineTitle}>{LINE_TITLE}</p>

        <button className={styles.reviewButton} onClick={handleToReview}>
          <span className={styles.reviewGlassTop} />
          <span className={styles.reviewGlassBottom} />
          <span className={styles.reviewLabel}>Залишити відгук</span>
        </button>

        <div className={styles.infoCard}>
          <div className={styles.infoText}>
            <p>Вміст Смол - {TAR} мг</p>
            <p>Вміст Нікотину - {NICOTINE} мг</p>
          </div>
          <img className={styles.tobacco} src={IMAGES.tobacco} alt="tobacco" />
        </div>

        <div className={styles.filterCard}>
          <div className={styles.filterMedia}>
            <span className={styles.filterGlow} />
            <img className={styles.filterImage} src={filterSrc} alt="filter" />
          </div>
          <div className={styles.filterText}>
            <p className={styles.filterTitle}>
              <b>
                Оригінальний
                <br />
                Recessed™{' '}
              </b>
              фільтр
            </p>
            <ul className={styles.filterList}>
              <li>Ацетатна частина</li>
              <li>Ущільнена повітряна камера</li>
            </ul>
          </div>
        </div>

        <button className={styles.rangeButton} onClick={handleToAllBrands}>
          <span className={styles.rangeGlassTop} />
          <span className={styles.rangeGlassBottom} />
          <span className={styles.rangeLabel}>Повний асортимент</span>
        </button>

        <div className={styles.linkCard} onClick={handleToAuthority}>
          <img
            className={styles.lensPack}
            src={IMAGES.lensPack}
            alt="lens-pack"
          />
          <p>
            Як <b>відрізнити оригінал</b> сигарет від підробки
          </p>
          <ChevronIcon />
        </div>

        <div className={styles.buyCard}>
          <div className={styles.buyInner}>
            <p className={styles.buyTitle}>{LINE_TITLE}</p>
            <p className={styles.buyDescription}>
              Актуальний асортимент можна знайти у роздрібних точках продажу в
              твоєму місті або на офіційних онлайн сервісах, зокрема:
            </p>
          </div>
          <div className={styles.buyButtons}>
            <ShopButton href={SHOP_LINKS.rozetka} label="rozetka" />
            <ShopButton href={SHOP_LINKS.cigPoshta} label="Cig-Poshta" />
          </div>
        </div>
      </div>

      <div className={styles.hwFooter}>
        <div>
          <p>Куріння викликає серйозні захворювання та залежність</p>
          <p>Дана інформація про продукт надається відповідно</p>
          <p>до статті 15 Закону України «Про захист прав споживачів»</p>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
